<!-- 修改库存盘点计划 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :visible.sync="dataActionBox.showStatus" title="修改库存盘点计划" :with-header="false" append-to-body center  width="60%" top="2rem">
			<el-form size="mini" label-position="top" label-width="120px" >
				<el-form-item label="货主">
					<el-input clearable @focus="$refs['showSelectData'].openBox('cargoOwnerList','coId','coId')" v-model="sendDataInfo.coName">
					</el-input>
				</el-form-item>
				<el-form-item label="开始时间">
					<el-date-picker v-model="sendDataInfo.ipmStime" style="width: 100%;" type="date" placeholder="开始时间" format="yyyy 年 MM 月 dd 日"  value-format="timestamp">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="库房">
					<el-select v-model="sendDataInfo.stId" style="width:100%">
						<el-option v-for="(storageRoomValue,storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName"  :value="storageRoomValue.stId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" maxlength="64"  show-word-limit v-model="sendDataInfo.ipmRemark">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction">提交信息</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
export default {
	name:'setStockLnventoryPlan',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
			},
			sendDataInfo:{
				"coId": "",
				coName:"",
				"ipmRemark": "",
				"ipmStime": "",
				"stId": ""
			},
			storageRoomList:[],
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		
		// 获取所有可用库房列表
		async getAllStorageRoom(){
			let responseData =  await this.$http.getAllStorageRoom()
			if(responseData.status == 200){
				this.storageRoomList = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			this.sendDataInfo.ipmStime = this.$moment().valueOf();
			this.dataActionBox.showStatus = false
		},
		
	
		async isShowData(name,value){
			switch(name){
				case 'coId':
					var dataInfo = JSON.parse(sessionStorage.getItem('selectCargoOwnerData'))
					if(dataInfo){
						console.log(dataInfo)
						this.sendDataInfo.coId = dataInfo.coId
						this.sendDataInfo.coName = dataInfo.coName
					}
			}
			
		},
	
		
		openBox(cate,oldData=''){
			this.initActionBox()
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			if(this.sendDataInfo.coId ==''){
				this.$message({
					message: '请选择货主',
					type: 'error'
				});
				return false
			}
			if(this.sendDataInfo.stId ==''){
				this.$message({
					message: '请选择库房',
					type: 'error'
				});
				return false
			}
			
			if(this.sendDataInfo.ipmStime==''){
				this.$message({
					message: '请选择开始时间',
					type: 'error'
				});
				return false
			}
			
			var responseData =  await this.$http.createStockLnventoryPlan(this.sendDataInfo)
			
			if(responseData.status == 200){
				this.initActionBox()
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
		this.getAllStorageRoom()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
